import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useOnCancelModal = () => {
  const { t } = useTranslation('host-reschedule');
  const { onOpenModal, onResetModal } = useModal();
  const navigate = useNavigate();

  const onOpenCancelModal = () => {
    onOpenModal({
      width: 'calc(100vw - 24px)',
      maxWidth: 'calc(100vw - 24px)',
      isOpen: true,
      type: 'cancel',
      title: t('confirm_cancel.title'),
      contentDescription: t('confirm_cancel.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('common:yes_cancel'),
      secondaryButtonText: t('common:close'),
      onClickPrimaryButton: () => {
        navigate(-1);
        onResetModal();
      },
    });
  };

  return onOpenCancelModal;
};

export default useOnCancelModal;
